import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';
import { Modal } from 'synfrastructure';
import cloneDeep from 'lodash/cloneDeep';
import { formatValidationErrors } from '../../common/utils/getApiReducer';
import { editChapter } from './actions';
import { addLesson, reorderLessons } from '../lessons/actions';
import { selectActiveCourse, selectActiveChapter, selectLessons } from '../selectors';

import AddForm from '../../common/forms/AddForm';
import Breadcrumb from '../../common/components/Breadcrumb';
import ChapterEditForm from './ChapterEditForm';
import Icon from '../../common/icons/Icon';
import LessonList from '../lessons/LessonList';
import { getUnassignedBadges } from '../actions';
import SortableListWrapper from '../../common/components/SortableListWrapper';

class ChapterEditPage extends Component {
  static propTypes = {
    activeCourse: PropTypes.object,
    activeChapter: PropTypes.object,
    courses: PropTypes.object,
    chapters: PropTypes.object,
    dispatch: PropTypes.func,
    initialValues: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      addLessonModalVisible: false,
      editingChapter: false,
    };
  }

  componentDidMount() {
    this.props.dispatch(getUnassignedBadges());
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.editingChapter && prevState.editingChapter !== this.state.editingChapter) {
      this.props.dispatch(getUnassignedBadges());
    }
  }

  toggleEdit = () => {
    this.setState(state => ({ editingChapter: !state.editingChapter }));
  };

  toggleAddLessonModal = () => {
    this.setState(state => ({ addLessonModalVisible: !state.addLessonModalVisible }));
  };

  onAddLessonSubmit = values => {
    const { activeCourse, activeChapter, dispatch } = this.props;

    return dispatch(addLesson(activeCourse.get('id'), activeChapter.get('id'), values)).then(action => {
      if (!action.response.ok) {
        throw new SubmissionError(formatValidationErrors(action.json).toJS());
      } else {
        this.props.history.push(
          `/courses/${activeCourse.get('id')}/chapters/${activeChapter.get('id')}/lessons/${action.json.id}`
        );
      }
    });
  };

  onEditChapterSubmit = values => {
    const { dispatch, match: { params: { courseId, chapterId } } } = this.props;
    const submitValues = cloneDeep(values);

    if (!submitValues.badge_id) {
      delete submitValues.badge_id;
    }

    return dispatch(editChapter(courseId, chapterId, submitValues)).then(action => {
      if (!action.response.ok) {
        throw new SubmissionError(formatValidationErrors(action.json).toJS());
      } else {
        this.setState(state => ({ editingChapter: false }));
      }
    });
  };

  renderLessons = () => {
    const { activeChapter, activeCourse, lessons, dispatch } = this.props;

    if (!activeCourse.get('published')) {
      return (
        <SortableListWrapper
          items={lessons}
          onSave={items => {
            return dispatch(reorderLessons({ lessonIds: items.map(lesson => lesson.id) }));
          }}
          title="Lessons"
        >
          <LessonList courseId={activeCourse.get('id')} chapterId={activeChapter.get('id')} />
        </SortableListWrapper>
      );
    } else {
      return <LessonList courseId={activeCourse.get('id')} chapterId={activeChapter.get('id')} />;
    }
  };

  render() {
    const { activeChapter, activeCourse, badges, initialValues, match } = this.props;
    const { addLessonModalVisible, editingChapter } = this.state;

    const breadcrumbs = [
      {
        label: 'Courses',
        to: '/courses',
      },
      {
        label: activeCourse.get('name'),
        to: `/courses/${match.params.courseId}`,
      },
      {
        label: activeChapter.get('name'),
        to: null,
      },
    ];

    return (
      <div>
        <div className="admin-paper">
          <Modal isVisible={addLessonModalVisible} onClose={this.toggleAddLessonModal}>
            <AddForm
              entityType="Lesson"
              initialValues={{ name: null }}
              onSubmit={this.onAddLessonSubmit}
              onCancel={this.toggleAddLessonModal}
            />
          </Modal>
          <div className="admin-paper__header">
            <Breadcrumb crumbs={breadcrumbs} />
            <button onClick={this.toggleAddLessonModal} className="admin__add-button">
              <Icon icon="Plus" /> Add Lesson
            </button>
          </div>
          {editingChapter ? (
            <ChapterEditForm
              badges={badges.get('data')}
              chapter={activeChapter}
              initialValues={initialValues}
              onSubmit={this.onEditChapterSubmit}
              onCancel={this.toggleEdit}
            />
          ) : (
            <div>
              <div className="admin-paper__edit-content">
                <div className="admin-paper__edit-content__row">
                  <p>Chapter Name</p>
                  <span className="title">{activeChapter.get('name')}</span>
                </div>
                <div className="admin-paper__edit-content__row">
                  <p>Chapter Description</p>
                  <span>
                    {activeChapter.get('description') ? activeChapter.get('description') : <em>No Description</em>}
                  </span>
                </div>
                <div className="admin-paper__edit-content__row">
                  <p>Chapter Badge</p>
                  <span>{activeChapter.getIn(['badge', 'name']) || 'None'}</span>
                </div>
                <div className="admin-paper__edit-button">
                  <button className="button" onClick={this.toggleEdit}>
                    Edit
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        {!editingChapter && this.renderLessons()}
      </div>
    );
  }
}

export default connect((state, ownProps) => {
  const activeCourse = selectActiveCourse(state.courses.courses, ownProps.match.params.courseId);
  const activeChapter = selectActiveChapter(state.courses.chapters, ownProps.match.params.chapterId);

  return {
    activeChapter,
    activeCourse,
    badges: state.courses.badges,
    chapters: state.courses.chapters,
    courses: state.courses.courses,
    initialValues: activeChapter
      ? {
          name: activeChapter.get('name'),
          description: activeChapter.get('description'),
          badge_id: activeChapter.get('badge_id') || '',
        }
      : null,
    lessons: selectLessons(state),
  };
})(ChapterEditPage);



// WEBPACK FOOTER //
// ./src/courses/chapters/ChapterEditPage.js